import api from "@/apis/UserSystem/UserAPI";
import Crud from "./crud-base";
import httpClient from "@/apis/base/axios-httpclient";
import getterCommon from "./getters";
import stateCommon from "./state";
var crud = new Crud("user", api);

const state = {
  ...crud.state,
  ...stateCommon,
  _config: {
    field: {
      key: "UserId",
      code: "UserName",
      name: "FullName",
    },
  },
  datas: [],
};
const getters = {
  ...crud.getters,
  ...getterCommon,
};
const actions = {
  ...crud.actions,
  /**
   * Đồng bộ người dùng
   * @returns danh sách người dùng được đồng bộ
   */
  //  syncUserFromAMIS: async function() {
  //    let request = {
  //      url: [api.getAPIUrl(), "sync_user"].join("/")
  //    };
  //    return await httpClient.getAsync(request);
  //  },

  /**
   * Lấy số lượng người có vai trò Quản lí ứng dụng
   * @returns số lượng người có vai trò Quản lí ứng dụng
   */
  // getAmountOfSystemManager: async function() {
  //   let request = {
  //     url: [api.getAPIUrl(), "get-amount-of-system-manager"].join("/")
  //   };
  //   return await httpClient.getAsync(request);
  // },

  /**
   * customer Load danh sách
   */
  async load(context, payload) {
    let res = null;
    try {
      context.commit("updateLoading", true);
      res = await api.getList(payload || {});
    } finally {
      context.commit("updateLoading", false);
    }

    if (res && !payload.notUpdateItem) {
      context.commit("setItems", { result: res, payload: payload });
    } else {
      context.commit("setDatas", { result: res, payload: payload });
    }

    return res;
  },
};
const mutations = {
  ...crud.mutations,
  setDatas(state, data) {
    if (data.result) {
      if (data.result.length > 0) {
        state.datas.removeAll();
        state.datas = data.result;
        //state.dataTotal = resultValue;
      }

      //   case "Total":
      //     state.dataTotal = resultValue;
      //     break;
      //   case "Empty":
      //     state.dataEmpty = resultValue;
      //     break;
      //   case "Summary":
      //     state.dataSummary = resultValue;
      //     break;
      // }
    }

    // state.items.removeAll();
    // state.items.append(res.PageData);
    // if (!res.payload || !res.payload.skip) {
    //   state.total = res.Total;
    //   state.empty = res.Empty;
    // }
  },
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
